import gql from 'graphql-tag';

export const sectionERAccountInfo = gql`
  fragment sectionERAccountInfo on SectionERAccountInfo {
    data {
      accountContact {
        firstName
        middleName
        lastName
        phoneNumber
        emailAddress
      }
      accountInfoInput {
        homeType
        preferredContact {
          firstName
          middleName
          lastName
          phoneNumber
          emailAddress
          relationship
        }
        useAccountContact
      }
      address {
        addressLine1
        city
        postal
        state
      }
    }
  }
`;

export const sectionERRebateInfo = gql`
  fragment sectionERRebateInfo on SectionERRebateInfo {
    data {
      chargerValidation {
        isQualifiedProduct
        product {
          brand
          dateAdded
          id
          name
          type
          modelNo
        }
      }
      mustVerifyResidentialMeter
      rebateInfo {
        availability {
          isAbleToRequestIQBD
          iqdbEnroll
          smartChargingRebate
        }
        existingEnrollments {
          iqbd
          evPulse {
            vin
          }
          smartCharging {
            serialNo
          }
          iqdb
        }
      }
      rebateInfoInput {
        chargerInstalledOnResidentialMeter
        evPulse {
          vin
          hasL2Charger
          driveTesla
          vinImage {
            id
          }
        }
        evPulseEnrollmentConfirmation {
          willEnrollNewSmartChargingDevice
          willEnrollNewVehicle
        }
        qualifiedProductInfo {
          serialNumber
          serialNumberImage {
            id
          }
        }
        smartCharging {
          modelNumber
          modelNumberImage {
            id
          }
        }
        smartChargingEnrollmentConfirmation {
          willEnrollNewSmartChargingDevice
        }
      }
    }
  }
`;

export const sectionERRebateConfirm = gql`
  fragment sectionERRebateConfirm on SectionERRebateConfirm {
    data {
      rebateInfo {
        availability {
          iqdbEnroll
          isAbleToRequestIQBD
          smartChargingRebate
        }
        existingEnrollments {
          evPulse {
            vin
          }
          iqbd
          smartCharging {
            serialNo
          }
        }
      }
      appliedRebate {
        ... on RebateSmartCharging {
          amount
          charger
          iqdb
          isHigherDiscount
          panelUpgrade
        }
        ... on RebateEVPulse {
          amount
        }
        ... on RebateBYOC {
          amount
        }
      }
      rebateEligibility {
        eligible
        evRebate {
          ... on RebateSmartCharging {
            amount
            charger
            iqdb
            isHigherDiscount
            panelUpgrade
          }
          ... on RebateEVPulse {
            amount
          }
          ... on RebateBYOC {
            amount
          }
        }
        ineligibilityReason
      }
      rebateConfirmInput {
        chargerInstallInfo {
          installationDate
          panelUpgraded
          installationCost
          chargerCost
          totalInstalationCost
          receiptImages {
            id
            name
            size
          }
        }
        confirmChargerConnectedToResidentialMeter
        confirmDriveElectricVehicle
        agreeToTermsAndConditions
        confirmEligibility
        confirmEligibility2
        iqbdQualification {
          checkEligibility
          grossIncome
          grossIncomeConfirmed
          houseHoldSize
        }
        rebateQualification {
          evPulse {
            chargerActivatedInAppConfirmed
            connectedEvPulseApp
            vin
            vinImage {
              id
            }
            willConnectEVPulseApp
          }
          smartCharging {
            chargerActivatedInApp
            chargerActivatedInAppConfirmed
          }
          wifiAvailable
        }
      }
      preRebateEligibility2 {
        eligible
        evRebate {
          ... on RebateSmartCharging {
            amount
            charger
            iqdb
            isHigherDiscount
            panelUpgrade
          }
          ... on RebateEVPulse {
            amount
          }
          ... on RebateBYOC {
            amount
          }
        }
        ineligibilityReason
      }
      preRebateEligibility1 {
        eligible
        evRebate {
          ... on RebateSmartCharging {
            amount
            charger
            iqdb
            isHigherDiscount
            panelUpgrade
          }
          ... on RebateEVPulse {
            amount
          }
          ... on RebateBYOC {
            amount
          }
        }
        ineligibilityReason
      }
    }
  }
`;

/** This is where we should tie in all of the ER application sections */
export const sectionERFragment = gql`
  fragment sectionERFragment on SectionER {
    sectionType
    ...sectionERAccountInfo
    ...sectionERRebateInfo
    ...sectionERRebateConfirm
  }
  ${sectionERAccountInfo}
  ${sectionERRebateInfo}
  ${sectionERRebateConfirm}
`;

export const sectionFragmentER = gql`
  fragment sectionFragment on ApplicationSection {
    id
    status
    errors {
      code
      message
    }

    ...sectionERFragment
  }

  ${sectionERFragment}
`;
